export const createEmbedQueryParamString = (embeds: string[]): string => {
  let result = '';
  for (const embed of embeds) {
    result = result + '&embed[]=' + embed;
  }
  return result;
};
